/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AptosErrorCode = {
    type: 'Enum',
} as const;
